import UserAgency from './UserAgency'
export default class LuAgency {
  constructor(objIn = {}) {
    const defaults = {
      //ID is required
      ID: 0,
      //Number is required
      Number: '',
      //Name is required
      Name: '',
      //Abr is required
      Abr: '',
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.ID = obj.ID
    this.Number = obj.Number
    this.Name = obj.Name
    this.Abr = obj.Abr
    this.UserAgencies = []
    if (obj.UserAgencies) {
      obj.UserAgencies.forEach((item) => {
        this.UserAgencies.push(new UserAgency(item))
      })
    }
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.UserAgencies = []
    if (this.UserAgencies) {
      this.UserAgencies.forEach((item) => {
        obj.UserAgencies.push(item.removeRelated())
      })
    }
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.UserAgencies = null
    return obj
  }
}
